export default function () {
  return {
    totalRedeemedDollars: 0,
    customer: null,
    coupons: {},
  }
}
